import { useEffect } from "react";

export default function GoogleLoginPage() {

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("token");

        if (!token) {
            window.location.href = "/";
            return;
        }

        validateToken(token);
    }, []);

    async function validateToken(token) {
        try {
            const response = await fetch(
                `https://gfcb8ed8eb8355a-st94sy8hnd7n7e0g.adb.ap-mumbai-1.oraclecloudapps.com/ords/leadmerge/lm_login/validate_token?token=${token}`
            );

            const data = await response.json();
            console.log("Validate Token Response:", data);

            if (data.status === 200) {
            localStorage.setItem("lm_user", JSON.stringify(data.user));
                window.location.href = "/dashboard";
            } else {
                alert("Invalid token");
                window.location.href = "/";
            }

        } catch (err) {
            console.error(err);
            window.location.href = "/";
        }
    }

    return (
        <div style={{ padding: 50, textAlign: "center" }}>
            <h2>Logging you in…</h2>
        </div>
    );
}
